import { render, staticRenderFns } from "./create-system-prompts.vue?vue&type=template&id=6dc995d8&scoped=true"
import script from "./create-system-prompts.vue?vue&type=script&lang=js"
export * from "./create-system-prompts.vue?vue&type=script&lang=js"
import style0 from "./create-system-prompts.vue?vue&type=style&index=0&id=6dc995d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc995d8",
  null
  
)

export default component.exports